import {toJS,reaction, makeObservable,observable } from 'mobx';
import switchStore from "./switchStore";
import translateStore from "./translateStore";
import meStore from "./meStore";
import appStateStore from "./appStateStore";
import chatStore from "./chatStore";
import blogStore from "./blogStore";
import photoStore from "./photoStore";
import figureStore from "./figureStore";

import qs from "qs";


class rootStore {
  stores={};
  router=null;
  url_vars={};
  marker_stores={};
  constructor(router, history) {
    makeObservable(this,{
      url_vars:observable
    })
    this.stores.router=router;
    this.stores.switchStore=new switchStore(this);
    this.stores.translateStore=new translateStore(this);
    this.stores.meStore=new meStore(this);
    this.stores.appStateStore=new appStateStore(this);
    this.stores.chatStore=new chatStore(this);
    this.stores.root=this;

    reaction(()=>{
      return this.stores.router.location.search;
    },(search)=>{
      this.url_vars=qs.parse(search.substr(1));
    },{ fireImmediately:true });

   // this.stores.blogStore=new blogStore(this);
  }
  constructBlogStore(config=null) {
    return new blogStore(this,config);
  }

  constructPhotosStore(config=null) {
    return new photoStore(this,config);
  }
  constructFiguresStore(config=null) {
    return new figureStore(this,config);
  }

  getStores() {
    return this.stores;
  }
}

export default rootStore;
